<script>
import SectionNewRegistration from '@/components/layouts/SectionNewRegistration'
import VContainer from '@/components/ui/VContainer'
import VHeadline from '@/components/ui/VHeadline'

import { mapState } from 'vuex'
import TabButton from '@/components/ui/TabButton.vue'

export default {
  name: 'SectionRegitration',
  computed: {
    ...mapState('forms', ['activeForm', 'forms', 'tabs']),
    title() {
      return this.$store.state.main.dic.register
    },

    activeFromClassName: function() {
      const arr = []
      if (this.activeForm === 'shippers') arr.push('shippers show')
      else if (this.activeForm === 'transporters') arr.push('transporters show')

      return arr
    },
  },

  render: function(createElement) {
    const tabs = this.tabs.map(({ label, type, form }) => {
      const isActive = form === this.activeForm ? true : false

      return createElement(
        TabButton,
        {
          props: {
            isActive,
            type,
            form,
          },
        },
        label
      )
    })

    const tabsMenu = createElement(
      VContainer,
      {
        class: ['tabs'],
        props: { bg: 'l', padding: false },
      },
      tabs
    )

    const header = createElement(
      VHeadline,
      {
        props: { level: 3 },
        class: ['form-headline', 'text-b'],
      },
      this.title
    )

    const bitrix = createElement(SectionNewRegistration)

    const formContainer = createElement(
      VContainer,
      {
        attrs: {
          id: 'form-container-registration',
        },
        class: ['form-container', this.activeFromClassName],
        props: { bg: 'l' },
      },
      [tabsMenu, bitrix]
    )

    const innerContainer = createElement('div', { class: ['form-inner'] }, [
      header,
      formContainer,
    ])

    const mainContainer = createElement(
      VContainer,
      {
        class: ['registration'],
        attrs: { id: 'form' },
        props: { bg: 'f', padding: false },
      },
      [innerContainer]
    )

    return mainContainer
  },
}
</script>

<style>
.registration {
  padding: 0 25px;
}

.form-container iframe {
  display: none;
}

.shippers #bx_form_iframe_6 {
  display: block;
  text-align: center;
}

.transporters #bx_form_iframe_16 {
  display: block;
  text-align: center;
}

.form-inner {
  max-width: 990px;
  margin: 0 auto;
  padding: 30px 0 50px 0;
}

.form-headline {
  width: 100%;
  font-weight: 500;
  padding: 20px 0;
}

.tabs {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="scss">
@media (max-width: 768px) {
}

@media (max-width: 375px) {
  .form-container {
    padding: 5px;
  }
}

@media (max-width: 414px) {
  .form-container {
    padding: 5px;
  }
}
</style>
